import {
  getMePermissionListQueryKey,
  mePermissionList,
  useMePermissionList,
} from "@/api/generated/endpoints/api"

export const meApi = {
  useMePermissionList,
  mePermissionList,
  getMePermissionListQueryKey,
}
